// extracted by mini-css-extract-plugin
module.exports = {"examChangeTableContainer":"ExamChangeTable_examChangeTableContainer__AVPea"};